
<div
  :class="jel_getClassObject(content)"
  class="d-flex justify-content-around justify-content-md-start py-2"
>
  <b-link :disabled="$i18n.locale == 'fr'" class="pr-md-4" :href="urlAutreLangue"
    >Français</b-link
  >
  <b-link :disabled="$i18n.locale == 'en'" class="pl-md-4" :href="urlAutreLangue">English</b-link>
</div>
